import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateSupplierActions } from "store/ducks/settings/suppliers";

export function* paginateSupplierRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/supplier?${queryString}`
    );

    const { supplier, pagination } = responseBody;
    yield put(PaginateSupplierActions.success(supplier, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateSupplierActions.failure(errorMessage));
  }
}
